import React, { useMemo } from 'react';
import { Alert } from '@televet/kibble-ui/build/components/Alert';
import useFeatureFlag from 'shared/hooks/useFeatureFlag';
import { FeatureFlagName } from 'shared/enums';

interface IFeeSaveAlertProps {
  serviceFee: number;
  showSaveAlert: boolean;
  styleProps?: React.CSSProperties;
}

const FeeSaveAlert = ({ serviceFee, showSaveAlert, styleProps }: IFeeSaveAlertProps): JSX.Element | null => {
  const { isFeatureEnabled } = useFeatureFlag();
  const showAlert = useMemo(() => {
    return isFeatureEnabled(FeatureFlagName.SurchargeUpdates) && serviceFee > 0 && showSaveAlert;
  }, [isFeatureEnabled, serviceFee, showSaveAlert]);

  return showAlert ? (
    <Alert
      iconProps={{ name: 'infoCircle', size: 'md' }}
      status="info"
      title={`Save $${serviceFee.toFixed(2)} by paying with Debit`}
      titleProps={{ size: 'xs' }}
      hideCloseButton={true}
      style={styleProps}
    />
  ) : null;
};
export default FeeSaveAlert;
